import { List } from 'immutable';
import { shareholderConstants } from '../constants';

export function shareholders(state = {}, action) {
  switch (action.type) {
    case shareholderConstants.SHAREHOLDER_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case shareholderConstants.SHAREHOLDER_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case shareholderConstants.SHAREHOLDER_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };

    case shareholderConstants.SHAREHOLDER_LIST_CLEAR:
      return {
        ...state,
        items: null
      };

    case shareholderConstants.SHAREHOLDER_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case shareholderConstants.SHAREHOLDER_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case shareholderConstants.SHAREHOLDER_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case shareholderConstants.SHAREHOLDER_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case shareholderConstants.SHAREHOLDER_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const shareholderIndex = state.items.findIndex(val => val.id == action.response.id);

      if (shareholderIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(shareholderIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case shareholderConstants.SHAREHOLDER_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case shareholderConstants.SHAREHOLDER_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case shareholderConstants.SHAREHOLDER_DELETE_SUCCESS: {
      const { shareholderId } = action;

      if (!state.items) {
        return state;
      }

      const shareholderIndex = state.items.findIndex(val => val.id == shareholderId);

      if (shareholderIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(shareholderIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case shareholderConstants.SHAREHOLDER_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };

    case shareholderConstants.SHAREHOLDER_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
